import { Navigate, useParams } from 'react-router';
import { periodFromDate } from '@finbob/shared';
import { useHousehold } from '@/features/household/api';
import { LoadingSkeleton as Spinner } from '@/components/ui/LoadingSkeleton';
import { useMonths } from '../api';
import { homePeriod } from '../lib/home-period';

/**
 * `/h/:hid/month` alone means the current period (docs/05-ui-design.md §3.1's URL) — or, once
 * that month is closed, the next month still to work on.
 */
export function MonthIndexRedirect() {
  const { hid = '' } = useParams<{ hid: string }>();
  const household = useHousehold(hid);
  const months = useMonths(hid);

  if (household.isLoading || months.isLoading) return <Spinner label="Loading household" />;
  if (!household.data) return null;

  const current = periodFromDate(new Date(), household.data.timezone);
  // A failed months list must not strand Home: fall back to the calendar month.
  const period = homePeriod(current, months.data ?? []);
  return <Navigate to={`/h/${hid}/month/${period}`} replace />;
}
